// extracted by mini-css-extract-plugin
export default {"container":"FormContainer_container__ztaf3","header":"FormContainer_header__1SSmb","body":"FormContainer_body__Ov9bx","closeDiv":"FormContainer_closeDiv__w3BE+"};